import { render, staticRenderFns } from "./Asetukset.vue?vue&type=template&id=2eb77706&scoped=true"
import script from "./Asetukset.vue?vue&type=script&lang=js"
export * from "./Asetukset.vue?vue&type=script&lang=js"
import style0 from "./Asetukset.vue?vue&type=style&index=0&id=2eb77706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb77706",
  null
  
)

export default component.exports